module.exports = __webpack_public_path__ + "img/img10.0f4bf1a5.png";